<div class="action-dull-input">
  <span>
    {{label}}
  </span>
</div>
